import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';
import {
  clearMaintenance,
  useMaintenanceState,
} from '@/contexts/maintenance/Maintenance.context.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

const HEALTH_CHECK_URL = '/actuator/health';
const HEALTH_CHECK_INTERVAL_MS = 30_000;

export const MaintenanceView: React.FC = () => {
  const { t } = useTranslationWithPrefix('views.util.maintenance');
  const { maintenanceEndDate, messagePl } = useMaintenanceState();

  useEffect(() => {
    const id = setInterval(async () => {
      try {
        // fetch zamiast instancji axiosa — omija maintenance interceptor.
        const res = await fetch(HEALTH_CHECK_URL, { cache: 'no-store' });
        if (res.ok) {
          clearMaintenance();
          globalThis.location.reload();
        }
      } catch {
        /* noop — kolejny ping spróbuje ponownie */
      }
    }, HEALTH_CHECK_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <Stack
      spacing={3}
      sx={{
        alignItems: 'center',
        background: themeColors.white,
        height: '100vh',
        justifyContent: 'center',
        px: 4,
      }}
    >
      <Typography
        color={themeColors.accentColorDark}
        sx={{
          textAlign: 'center',
        }}
        variant="f32Medium"
      >
        {t('title')}
      </Typography>
      <Typography
        color={themeColors.accentColorDark}
        sx={{
          textAlign: 'center',
        }}
        variant="f24Medium"
      >
        {messagePl ?? t('fallbackMessage')}
      </Typography>
      {maintenanceEndDate && (
        <Typography
          color={themeColors.accentColorDark}
          sx={{
            textAlign: 'center',
          }}
          variant="f18Medium"
        >
          {t('endDateLabel')}: {maintenanceEndDate}
        </Typography>
      )}
    </Stack>
  );
};
